function getCookie(name) {
    return document.cookie.split(';').map(c => c.trim()).find(c => c.startsWith(name + '='))?.split('=')[1];
}

export function authHeaders() {
    return {
        'x-email': getCookie('email') ?? '',
        'x-session-token': getCookie('session_token') ?? ''
    };
}
